module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "myRecommend"
  }, [_c('mt-loadmore', {
    ref: "loadmore",
    attrs: {
      "top-method": _vm.loadTop,
      "bottom-method": _vm.loadBottom,
      "bottom-all-loaded": _vm.allLoaded,
      "auto-fill": false
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [_c('ul', {
    staticClass: "myRecommend_list pjt_list"
  }, _vm._l((_vm.pjtLists), function(pjtList, index) {
    return _c('li', {
      key: index
    }, [_c('div', {
      on: {
        "click": function($event) {
          return _vm.toDetail(pjtList)
        }
      }
    }, [(pjtList.readFlag == 0) ? _c('div', {
      staticClass: "red_dot"
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "bgImg",
      class: {
        'zhaomu': pjtList.status == 4, 'close': pjtList.status == 2, 'close1': pjtList.status == 3, 'close2': pjtList.status == 5, 'jinxing': pjtList.status == 7, 'over': pjtList.status == 8, 'hezuo': pjtList.status == 6, 'pingjia': pjtList.status == 9, 'shenhe': pjtList.status == 1
      }
    }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(pjtList.title))]), _vm._v(" "), _c('span', {
      staticClass: "pjt_type"
    }, [_vm._v(_vm._s(pjtList.typeName))]), _vm._v(" "), _c('div', {
      staticClass: "path"
    }, [_c('div', {
      staticClass: "money"
    }, [_c('span', [_vm._v("项目预算")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(pjtList.prepriceName))])]), _vm._v(" "), _c('div', {
      staticClass: "time"
    }, [_c('span', [_vm._v("时间周期")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(pjtList.periodName))])])]), _vm._v(" "), _c('div', {
      staticClass: "skills"
    }, _vm._l((pjtList.skillsList), function(skillsList, index) {
      return _c('span', {
        key: index
      }, [_vm._v(_vm._s(skillsList))])
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "position"
    }, [_c('span', [_c('icon', {
      attrs: {
        "name": "map-marker"
      }
    }), _vm._v(_vm._s(pjtList.cityName))], 1), _c('span', [_c('icon', {
      attrs: {
        "name": "clock-o"
      }
    }), _vm._v(_vm._s(pjtList.time))], 1)]), _vm._v(" "), _c('div', {
      staticClass: "describe"
    }, [_c('p', [_vm._v("需求描述:")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "-webkit-box-orient": "vertical"
      }
    }, [_vm._v(_vm._s(pjtList.description))])])]), _vm._v(" "), _c('div', {
      staticClass: "people"
    }, [_c('span', [_vm._v("已推荐"), _c('span', [_vm._v(_vm._s(pjtList.countRecommender))]), _vm._v("人")]), _c('span', [_c('i', {
      staticClass: "people_icon"
    }), _vm._v("已申请"), _c('span', [_vm._v(_vm._s(pjtList.countOffer))]), _vm._v("人")]), _c('span', [_c('i', {
      staticClass: "people_icon"
    }), _vm._v("已浏览"), _c('span', [_vm._v(_vm._s(pjtList.countVisit))]), _vm._v("人")]), _vm._v(" "), (pjtList.status === 4) ? _c('button', {
      staticClass: "sendBtn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.sendApply(pjtList)
        }
      }
    }, [_vm._v("发送申请")]) : _vm._e()])])
  }), 0)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-650e1773","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/myRecommend_pjt.vue
// module id = 1282
// module chunks = 1